import AppSimpleBar from "components/AppSimpleBar";
import { getContentUnreadCount } from "../../../redux/actions";
import { useDispatch } from "react-redux";
import { useRedux } from "hooks";
import { useEffect, useRef, useState } from "react";
import { APIClient } from "api/apiCore";
import { Tooltip } from "react-tooltip";

import { OverlayTrigger, Popover, Button } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";

const TestDispatch = () => {
    const { dispatch, useAppSelector } = useRedux();
    const onClick = () => {
        //console.log('dispatch(getContentUnreadCount(12, 13));');
        dispatch(getContentUnreadCount(12, 13));
    }

    return (<button onClick={onClick}>test dispatch</button>);
}

const TestGetWithCookie = () => {
    const setCookie = (name: string, value: string): void => {
        const days = 20;
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    };

    const getCookie = (name: string): string | null => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    };

    const [cookieValue, setCookieValue] = useState(getCookie("WEB_ID"));
    const [dUrl, setDUrl] = useState(`https://localhost:7002/`)
    const [dCookieApi, setDCookieApi] = useState('https://localhost:7002/Home/SetCookie');

    const generateRandomNumber = () => {
        const number = Math.floor(Math.random() * 1000) + 1; // Random number between 1 and 1000
        return number;
    };

    const onRegisterCookie = () => {
        if (webId) {
            const cookieValueSet = webId;
            //console.log('call api ' + dCookieApi + ' with value + ' + webId);
            // Call the WebMethod using fetch
            fetch(dCookieApi, {
                method: "POST",
                credentials: "include", // Ensures cookies are included in the response
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(cookieValueSet) // Replace "exampleValue" with the actual value
            })
                .then(response => response.json())
                .then(data =>
                    alert(dCookieApi + '\n' + data.message)
                )
                .catch(error => console.error("Error:", error));
        } else {
            alert('Please input web id');
        }
    }

    const [webId, setWebId] = useState<string>("123");
    useEffect(() => {
        setWebId(generateRandomNumber().toString());
    }, []);

    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    const handleLinkClick = () => {
        // Perform your checks here
        const someCondition = true; // Replace with your actual condition

        if (someCondition) {
            setIsTooltipOpen(true); // Show tooltip programmatically
            setTimeout(() => {
                setIsTooltipOpen(false); // Auto-hide tooltip after delay
            }, 2000); // Adjust delay as needed
        }
    };

    return (
        <>
            Set Cookie API<br />
            <input type="text" width="100%" value={dCookieApi}
                onBlur={(e) => setDCookieApi(e.target.value)} // Use `e.target.value` to get the input value
                onChange={(e) => setDCookieApi(e.target.value)} // Optional: Sync value on change if needed
            ></input>


            WEB_ID = <input type="text" style={{ "width": "50px" }} value={webId} onChange={(e) => setWebId(e.target.value)}></input>
            <button onClick={onRegisterCookie}>Set Web ID Cookie</button>
            <br />

            <br />
            URL DCONNECT<br />
            <input type="text" width="100%" value={dUrl}
                onBlur={(e) => setDUrl(e.target.value)} // Use `e.target.value` to get the input value
                onChange={(e) => setDUrl(e.target.value)} // Optional: Sync value on change if needed
            ></input>
            <br /><br />
            Open by tag hyper link<br />
            <a href={dUrl} target="_blank">Tag A</a>
            <br /><br />

            <a data-tooltip-id="my-tooltip" data-tooltip-content="Hello world!" onClick={handleLinkClick} >
                Word
            </a>
            <Tooltip id="my-tooltip" isOpen={isTooltipOpen} />

        </>
    );
}



const TestCode = () => {



    return (
        <>
            <div className="position-relative p-3">
                <AppSimpleBar className="p-3 test-lazy-load">
                    <div>
                        {TestDispatch()}
                        <hr />
                        {TestGetWithCookie()}
                    </div>
                </AppSimpleBar>
            </div>

        </>
    );
}

export default TestCode;